import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative h-screen w-full overflow-hidden" data-id="element-137">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-138">
        <img src="https://cdn.magicpatterns.com/uploads/d3XDSHtuc9vayzSX7JJKWc/cheapest-gold-in-africa.jpg" alt="Premium Gold from RDC" className="w-full h-full object-cover" data-id="element-139" />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/30" data-id="element-140" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4 sm:px-6 lg:px-8" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-4xl mx-auto" data-id="element-142">
          <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight mb-6" data-id="element-143">
            Premium Minerals <br data-id="element-144" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-drc-yellow to-yellow-400" data-id="element-145">
              From the RDC
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-146">
            Certified mining and mineral trading company specializing in Gold,
            Diamonds, and Gemstones. Trusted global supplier of ethically
            sourced minerals.
          </p>

          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-147">
            <a href="#collection" className="inline-flex items-center px-8 py-4 border border-transparent text-base font-medium rounded-full text-white bg-drc-blue hover:bg-drc-light transition-colors duration-300 shadow-lg hover:shadow-xl" data-id="element-148">
              Explore Collection
            </a>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white/70 z-10" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-149">
        <ArrowDown size={32} data-id="element-150" />
      </motion.div>
    </section>;
}